import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Rotas} from 'src/app/core/rotas';
import {BaseService} from '../base/base.service';
import {ConjuntoCategoriaContabil} from '../../core/conjunto-categoria-contabil';

@Injectable({
    providedIn: 'root'
})
export class ConjuntoCategoriaContabilService extends BaseService<ConjuntoCategoriaContabil> {

    constructor(http: HttpClient) {
        super(http, Rotas.CONJUNTOS_CATEGORIA_CONTABIL);
    }

    getByDescricao(descricaoTransacao: string, categoriaOrigem?: number, categoriaDestino?: number) {
        let params = new HttpParams()
            .set('descricao', descricaoTransacao);

        if (categoriaOrigem != null) {
            params = params.set('categoriaOrigem', categoriaOrigem.toString());
        }

        if (categoriaDestino != null) {
            params = params.set('categoriaDestino', categoriaDestino.toString());
        }

        return this.http.get(Rotas.CONJUNTOS_CATEGORIA_CONTABIL + 'buscarPorDescricaoECategoria', {params: params});
    }

    getByCategorias(categoriaOrigem: number, categoriaDestino: number) {
        let params = new HttpParams()
            .set('categoriaOrigem', categoriaOrigem.toString())
            .set('categoriaDestino', categoriaDestino.toString());
        return this.http.get(Rotas.CONJUNTOS_CATEGORIA_CONTABIL + 'buscar', {params: params});
    }

    getByFiltros(categoriaOrigem?: number | null, categoriaDestino?: number | null, ativo?: string | null, descricaoArgumentos?: string | null) {
        let params = new HttpParams();

        if (categoriaOrigem != null) {
            params = params.set('categoriaOrigem', categoriaOrigem.toString());
        }

        if (categoriaDestino != null) {
            params = params.set('categoriaDestino', categoriaDestino.toString());
        }

        if (ativo != null && ativo !== 'todos') {
            params = params.set('ativo', ativo);
        }

        if (descricaoArgumentos != null && descricaoArgumentos.trim() !== '') {
            params = params.set('descricaoArgumentos', descricaoArgumentos.trim());
        }

        return this.http.get<ConjuntoCategoriaContabil[]>(Rotas.CONJUNTOS_CATEGORIA_CONTABIL + 'filtrar', {params: params});
    }
}
